import React from 'react';
import { combineClassNames } from '../../../../app/functions';
import removeIcon from '../../../../assets/icons/x-close-white-icon.svg';
import './index.scss';

const Tag = ({
    data,
    clickable = false,
    selectable = false,
    isSelected = false,
    removable = false,
    onTagClick = () => {},
    onRemove = () => {},
}) => {
    const handleClickEvent = () => onTagClick(data.id);

    const handleRemoveClick = (event) => {
        event.stopPropagation();
        onRemove(data.id);
    };

    const showRemoveIcon = removable && selectable && isSelected;

    return (
        <div
            className={combineClassNames(
                'shared-tag',
                clickable && 'shared-tag_clickable',
                selectable && isSelected && 'shared-tag_selected',
                selectable && !isSelected && 'shared-tag_unselected',
                showRemoveIcon && 'shared-tag_removable',
            )}
            onClick={handleClickEvent}
        >
            {data.title}
            {showRemoveIcon ? (
                <button
                    type="button"
                    className="shared-tag__remove"
                    onClick={handleRemoveClick}
                    aria-label="הסר סינון"
                >
                    <img src={removeIcon} alt="" className="shared-tag__remove-icon" />
                </button>
            ) : null}
        </div>
    );
};

export default Tag;
